import { ITeamDetails, ITeamStandings, UID } from '@shared/types';
import { useAppSelector } from 'app/hooks';
import { getSelectedSeasonWeek, getSelectedTeamName, getSelectedWeek } from 'app/slices/GamesSlice';
import { getSelectedTeamDetails, getUIDScheduleForSelectedTeam } from 'app/slices/LeagueSlice';
import { getSelectedTeamStanding } from 'app/slices/RankingSlice';
import { breakUID } from 'helpers/IdHelpers';
import { useEffect, useMemo, useState } from 'react';
import useSeasonStandings from './useSeasonStandings';

const useSelectedTeamInfo = () => {
  const selectedTeamName = useAppSelector(getSelectedTeamName);
  const selectedWeek = useAppSelector(getSelectedWeek);
  const selectedSeasonWeekID = useAppSelector(getSelectedSeasonWeek);
  const teamDetails: ITeamDetails | undefined = useAppSelector(getSelectedTeamDetails);
  const teamStandings = useAppSelector(getSelectedTeamStanding);
  const { getDivisionStandings, weeklyTeamStandings } = useSeasonStandings();

  const [divisionTeams, setDivisionTeams] = useState<ITeamDetails[]>([]);

  const schedule: UID[] = useAppSelector(getUIDScheduleForSelectedTeam);

  useEffect(() => {
    if (selectedTeamName && teamDetails && selectedSeasonWeekID) {
      const divStandings = getDivisionStandings(teamDetails.teamDivision);
      setDivisionTeams(divStandings);
    }
  }, [getDivisionStandings, selectedTeamName, teamDetails, selectedSeasonWeekID]);

  const selectedTeamStandingsBySeasonWeekID = useMemo(() => {
    return teamStandings.find((team: ITeamStandings) => breakUID(team.uID).seasonWeekID === selectedSeasonWeekID);
  }, [teamStandings, selectedSeasonWeekID]);

  return {
    schedule,
    teamName: selectedTeamName,
    teamDetails,
    teamStandings: selectedTeamStandingsBySeasonWeekID,
    selectedWeek,
    divisionTeams,
    weeklyTeamStandings,
  };
};

export default useSelectedTeamInfo;
